iframeService.$inject = [
  '$window',
  '$timeout',
  'loggerService',
  '$stateParams'
];

export default function iframeService($window, $timeout, logger, $stateParams) {
  class IframeService {
    postMessage(message, targetOrigin) {
      $timeout(() => {
        targetOrigin = targetOrigin || '*';

        message.widgetId = $stateParams.widget_id;

        message = JSON.stringify(message);

        if (!this.inIframe()) {
          return;
        }

        $window.top.postMessage(message, targetOrigin);
      });
    }

    inIframe() { //eslint-disable-line
      try {
        return $window.self !== $window.top;
      } catch (e) {
        return true;
      }
    }
  }

  return new IframeService();
}



// WEBPACK FOOTER //
// ./src/services/iframeService.js